import { env } from '../constants/env';

export const STATE_OPTIONS = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'D.C.',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
} as const;

export type VALID_US_STATES_TYPE = keyof typeof STATE_OPTIONS;

// Allow overriding the list via ENV variable to simplify rollout
export const INDEPENDENT_AGENT_STATES: VALID_US_STATES_TYPE[] =
  env.independentAgentStates && env.independentAgentStates.trim() !== ''
    ? env.independentAgentStates
        .split(',')
        .filter((state): state is VALID_US_STATES_TYPE =>
          Object.keys(STATE_OPTIONS).includes(state)
        )
    : [
        'AL',
        'AZ',
        'CA',
        'FL',
        'GA',
        'IL',
        'IN',
        'KY',
        'LA',
        'MD',
        'MO',
        'MS',
        'NE',
        'OH',
        'OK',
        'PA',
        'TX',
        'UT',
        'VA',
        'WI',
        'WV',
      ];

export type StateOptionsType = Record<VALID_US_STATES_TYPE, string> | {};

export const US_PREFIXED_STATE_OPTIONS: Record<string, string> = Object.entries(
  STATE_OPTIONS
).reduce(
  (acc, [key, value]) => ({
    ...acc,
    [`US-${key}`]: value,
  }),
  {}
);

export const isValidUsStatesType = (
  state: string
): state is VALID_US_STATES_TYPE => STATE_OPTIONS.hasOwnProperty(state);
